import { useState } from 'react';

import { useSelector, useDispatch } from 'react-redux';

import { useNavigate } from 'react-router-dom';

import Config from '../../../helpers/Config';

import { clearPunchOut } from '../../../stateManagment/features/punchoutSlice';



//-- Replaces the Checkout CTA while inside a PunchOut session. Posts the current cart to the

//-- backend return endpoint; on success navigates to /punchout/returning which auto-submits

//-- the BrowserFormPost form and sends the buyer back to Coupa.

const buildReturnItems = (products = []) => {

    return products

        .filter((p) => p && (p.productId || p.lineItemId))

        .map((p) => {

            const unitPrice = (p.discountedPrice && p.discountedPrice > 0)

                ? p.discountedPrice

                : (p.price ?? p.productPrice ?? 0);

            const descriptionParts = [p.productName, p.colorName, p.sizeShortName].filter(Boolean);

            return {

                supplierPartId: p.productId ?? '',

                supplierPartAuxiliaryId: p.lineItemId ?? null,

                quantity: p.quantity ?? 1,

                unitPrice,

                currency: Config.APP_SETTING?.DefaultCurrencyCode ?? 'USD',

                description: descriptionParts.join(' - '),

                unitOfMeasure: 'EA'

            };

        });

};



const ReturnCartButton = ({ className = 'btn btn-primary w-100', disabled = false }) => {

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const { sessionId, provider, canReturn } = useSelector((state) => state.punchoutReducer);

    const { products } = useSelector((state) => state.cartReducer);

    const [isSubmitting, setIsSubmitting] = useState(false);

    const [errorMessage, setErrorMessage] = useState('');



    //-- inspect sessions are read-only: no cart return is offered (backend also rejects it).

    if (canReturn === false) {

        return null;

    }



    const providerLabel = provider ? `Return Cart to ${provider}` : 'Return Cart';



    const handleReturn = async () => {

        if (isSubmitting) return;

        setErrorMessage('');



        if (!sessionId) {

            setErrorMessage('Your PunchOut session is missing. Please restart from your procurement system.');

            return;

        }



        const items = buildReturnItems(products);

        if (items.length === 0) {

            setErrorMessage('Your cart is empty.');

            return;

        }



        setIsSubmitting(true);

        try {

            const baseUrl = Config.ENV_ADMIN_BASE_URL ?? Config.ADMIN_BASE_URL;

            const url = `${baseUrl}api/v1/punchout/session/${encodeURIComponent(sessionId)}/return`;



            const response = await fetch(url, {

                method: 'POST',

                headers: { 'Content-Type': 'application/json' },

                body: JSON.stringify({ items })

            });



            const result = await response.json().catch(() => null);



            if (response.ok && result?.success === true && result.browserFormPostUrl && result.encodedCxml) {

                localStorage.removeItem('PunchOutSessionId');
                localStorage.removeItem('PunchOutActive');

                dispatch(clearPunchOut());

                navigate('/punchout/returning', {

                    replace: true,

                    state: {

                        browserFormPostUrl: result.browserFormPostUrl,

                        encodedCxml: result.encodedCxml,

                        provider: provider || undefined

                    }

                });

                return;

            }



            setErrorMessage(result?.message || 'We could not return your cart. Please try again.');

        } catch (err) {

            setErrorMessage('We could not return your cart. Please try again.');

        } finally {

            setIsSubmitting(false);

        }

    };



    return (

        <>

            <button

                type="button"

                className={className}

                onClick={handleReturn}

                disabled={disabled || isSubmitting}

            >

                {isSubmitting ? 'Returning...' : providerLabel}

            </button>

            {errorMessage

                ? <div className="text-danger mt-2" role="alert">{errorMessage}</div>

                : null}

        </>

    );

};



export default ReturnCartButton;


